import styles from './Card.module.css';

interface CardProps {
  children: React.ReactNode;
  header?: string;
  className?: string;
}

export function Card({ children, header, className = '' }: CardProps) {
  return (
    <div className={`${styles.card}${className ? ` ${className}` : ''}`}>
      {header && (
        <div className={styles.cardHeader}>
          <h2>{header}</h2>
        </div>
      )}
      {children}
    </div>
  );
}
